import React from 'react';

import { AutoCompleteSelectUI, FormErrorUI, FormLabelUI } from '../../Interface';

const WarehouseField = ({
  value,
  onChange,
  warehouseData,
  warehouseOptions,
  helperText,
  variant = 'standard',
  fullWidth = true,
  ...rest
}) => {
  return (
    <AutoCompleteSelectUI
      fullWidth={fullWidth}
      label={<FormLabelUI text="Raktár" />}
      variant={variant}
      helperText={helperText ? <FormErrorUI message={helperText} /> : undefined}
      InputLabelProps={{ shrink: Boolean(value) }}
      onChange={(_e, newVal) => onChange(newVal?.value ?? null)}
      selectedValue={value}
      selectedLabelValue={warehouseData?.find((warehouse) => warehouse.code === value)?.code ?? ''}
      dataset={warehouseOptions}
      {...rest}
    />
  );
};

export default WarehouseField;